import { Col } from "react-grid-system";
import styled from "styled-components";

export const StyledUnitFooter = styled(Col)`
	display: flex;
	flex-wrap: wrap;
	column-gap: 1.6rem;
	row-gap: 1.6rem;
`;
